import { render, staticRenderFns } from "./VehicleCustomer.vue?vue&type=template&id=4bc2c99c"
import script from "./VehicleCustomer.vue?vue&type=script&lang=js"
export * from "./VehicleCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports